import {connect} from "react-redux";
import ApprovalPendingList from "./ApprovalList";
import {bindActionCreators} from "redux";
import {approvalPending} from "../../../../service/FasttagToll/action";
import {approvalActivity} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    approvalPendingList: state.FasttagToll.approvalPendingList,
    approved: state.FasttagToll.approved,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            approvalPending,
            approvalActivity,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalPendingList);
